import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconInfo = (props) => (
  <Icon fill="none" {...props}>
    <path
      d="M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.161 6.7366V8.06831C16.161 8.30734 15.9561 8.51221 15.7171 8.51221H14.7269C14.4878 8.51221 14.283 8.30734 14.283 8.06831V6.7366C14.283 6.49758 14.4878 6.2927 14.7269 6.2927H15.7171C15.9561 6.2927 16.161 6.49758 16.161 6.7366ZM16.161 12.3707V22.7854C16.161 23.0244 15.9561 23.2293 15.7171 23.2293H14.7269C14.4878 23.2293 14.283 23.0244 14.283 22.7854V12.3707C14.283 12.1317 14.4878 11.9268 14.7269 11.9268H15.7171C15.9561 11.9268 16.161 12.1317 16.161 12.3707Z"
      fill="currentColor"
    />
  </Icon>
);
